import { forgetFundingCustomer } from '../discovery/discover-checkout.js';
import { clearCheckoutProgress } from './checkout-progress.js';
export function fundingDisconnectActions(options) {
    const { client, cache, navigation, active, setBusy, setError } = options;
    const canDisconnect = options.state === 'profile' && !options.attemptId && !options.busy;
    return {
        canDisconnect,
        async disconnect() {
            if (!canDisconnect || active.current || navigation.getSnapshot().checkout !== 'profile')
                return false;
            const controller = new AbortController();
            active.current = controller;
            setBusy(true);
            setError(null);
            try {
                if (!options.provider.resetConnection)
                    throw new Error('onramp_disconnect_unsupported');
                // MoonPay's reset frame needs the current client token, which backend revocation invalidates.
                await options.provider.resetConnection();
                if (controller.signal.aborted)
                    return false;
                await client.disconnectSession(controller.signal);
                if (controller.signal.aborted)
                    return false;
                forgetFundingCustomer(options.provider);
                await cache.cancelQueries({ queryKey: ['onramp', client.cacheKey] });
                if (controller.signal.aborted)
                    return false;
                cache.removeQueries({
                    predicate: ({ queryKey }) => queryKey[0] === 'onramp' &&
                        queryKey[1] === client.cacheKey &&
                        !['history', 'operation', 'pending', 'action-recovery'].includes(String(queryKey[2])),
                });
                clearCheckoutProgress(client.progressKey ?? client.cacheKey);
                // Disconnect explicitly revokes authentication; a new payment alone does not.
                navigation.deposit();
                options.onSessionRefresh?.('disconnect');
                return true;
            }
            catch {
                if (!controller.signal.aborted)
                    setError('disconnect_failed');
                return false;
            }
            finally {
                if (active.current === controller)
                    active.current = null;
                if (!controller.signal.aborted)
                    setBusy(false);
            }
        },
    };
}
